import {AfterViewChecked, ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {KeycloakService} from 'keycloak-angular';
import {LookupService} from '../../../../common/services/lookup.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NameValueDTO} from '../../../../common/models/NameValueDTO';
import {DateUtil} from '../../../../common/util/DateUtil';
import {AssessmentNarrativeDTO} from '../../../models/AssessmentNarrativeDTO';
import {SharedService} from '../../../../common/services/shared-service';
import {LookupValue} from '../../../types/lookup-value.enum';

@Component({
  selector: 'app-add-justification-dialog',
  templateUrl: './add-justification-dialog.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss']
})
export class AddJustificationDialogComponent implements OnInit, AfterViewChecked {
  readonly dateFormat = DateUtil.dateFormat;
  readonly lookupValue = LookupValue;

  justificationFormGroup: FormGroup;
  justificationFormControl: FormControl;
  actionRequiredFormControl: FormControl;

  assessmentNarrativeTypes: NameValueDTO[];
  assessmentNarrative: AssessmentNarrativeDTO;

  heading = 'Add Justification';
  assessmentDate = new Date();
  userFirstLastName = '';
  isEdit = false;

  constructor(
    private changeDetect: ChangeDetectorRef,
    public dialogRef: MatDialogRef<AddJustificationDialogComponent>,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private keycloakService: KeycloakService,
    private lookupService: LookupService,
    private sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    let justification = '';
    let actionRequired = '';
    if (data != null) {
      this.isEdit = true;
      this.heading = 'Edit Justification';
      this.assessmentNarrative = data;
      justification = this.assessmentNarrative.assessmentActionDescription;
      actionRequired = this.assessmentNarrative.assessmentNarrativeType.name;
    } else {
      this.assessmentNarrative = new AssessmentNarrativeDTO();
    }

    this.justificationFormControl = new FormControl(justification, Validators.required);
    this.actionRequiredFormControl = new FormControl(actionRequired, Validators.required);
    this.justificationFormGroup = this.formBuilder.group({
      justification: this.justificationFormControl,
      actionRequired: this.actionRequiredFormControl
    });
  }

  ngOnInit(): void {
    this.getListOfLookupValues(this.lookupValue.AssessmentNarrativeType);
    this.getHelpInfo('Assessment Narrative');

    this.keycloakService.loadUserProfile().then(profile => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });
  }

  ngAfterViewChecked(): void {
    this.changeDetect.detectChanges();
  }

  getListOfLookupValues(entity: string): void {
    this.lookupService.getListOfLookupValues(entity).subscribe(
      (response: NameValueDTO[]) => {
        if (entity === this.lookupValue.AssessmentNarrativeType) {
          this.assessmentNarrativeTypes = response;
        }
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.openSnackBar(error.businessMessage, 'Dismiss');
      }
    );
  }

  getHelpInfo(componentName: string) {
    this.sharedService.getHelpInfo(componentName);
  }

  getInfoTooltip(inputName: string): string {
    return this.sharedService.getInfoTooltip(inputName);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 10000
    });
  }

  getAssessmentUser(): string {
    const existingNarrativeUser = this.assessmentNarrative.updatedBy != null ? this.assessmentNarrative.updatedBy : this.assessmentNarrative.createdBy;
    return this.isEdit ? existingNarrativeUser : this.userFirstLastName;
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  onSaveClick() {
    if (this.justificationFormGroup.valid) {
      this.assessmentNarrative.assessmentActionDescription = this.justificationFormControl.value;
      this.assessmentNarrative.assessmentNarrativeType = this.assessmentNarrativeTypes.find(type => type.name === this.actionRequiredFormControl.value);
      if (this.isEdit) {
        this.assessmentNarrative.updated = new Date();
        this.assessmentNarrative.updatedBy = this.userFirstLastName;
      } else {
        this.assessmentNarrative.created = new Date();
        this.assessmentNarrative.createdBy = this.userFirstLastName;
      }
      this.dialogRef.close(this.assessmentNarrative);
    } else {
      this.openSnackBar('Please complete all required fields.', 'Dismiss');
    }
  }

  onCancelClick() {
    this.dialogRef.close(null);
  }
}
